import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs"
import React, { useEffect, useState } from "react"
import { Grid, Typography } from "@mui/material"
import { gridSizeMdLg12 } from "@/shared"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from "@fullcalendar/interaction"
import timeGridPlugin from "@fullcalendar/timegrid"
import esLocale from "@fullcalendar/core/locales/es"
import { postPlanificadorFlotaSoftnet } from "@/shared/actions/erp/operaciones/softnet-seguimientoactividades/soft-seguimientoactividades.actions";
import { CalendarEventSeguimientoAct } from "@/shared/actions/erp/operaciones/softnet-seguimientoactividades"
import dayjs from "dayjs"
import { EventContentArg } from "@fullcalendar/core/index.js"

type Props = {
    data: any
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const ModalSeguimientoFlotaPlanificador = ({
    data,
    open,
    setOpen
}: Props) => {
    const handleClose = () => {
        setEvents([]);
        setOpen(false);
    };
    const [events, setEvents] = useState<CalendarEventSeguimientoAct[]>([]);



    function returnSoftnetEvents (
        events: CalendarEventSeguimientoAct[], 
        // withSetEvents: boolean = false
    ) {
        const result = events.map((event: CalendarEventSeguimientoAct) => {
            const start = dayjs(event.start);
            const end = dayjs(event.end);
            return {
                ...event,
                title: event.title||"xD",
                textColor: "#ffffff",
                backgroundColor: event.color||"red",
                start: start.toDate(),
                end: end.toDate(),
                tipo: event.tipo,
            };
        })
        // if(withSetEvents) setEvents(result);
        return result;
    }

    // const filterThisDayEvents = (events: CalendarEventSeguimientoAct[], arg?: any) => {
    //     return events.filter(
    //         (event: CalendarEventSeguimientoAct) => 
    //             dayjs(event.start).isSame(dayjs(arg?.start ?? data?.fecha), "day")
    //     );
    // }

    
    const fetchEvents = async () => {
        if(!data?.id_tecnico) return;
        const events = await postPlanificadorFlotaSoftnet(`T-${data?.id_tecnico}`, {anio: dayjs(data?.fecha).year(), mes: dayjs(data?.fecha).month()});

        // const thisDayEvents = events?.data//filterThisDayEvents(events?.data)
        const result = returnSoftnetEvents(events?.data || [])
        setEvents(result);
    }

    useEffect(() => {
        if(!open) return;
        fetchEvents();
    }, [open])

    // useEffect(() => {
    //     if(!dataSetEvents) return;
    //     const thisDayEvents = filterThisDayEvents(dataSetEventsFetched)
    //     const result = returnSoftnetEvents(thisDayEvents)
    //     setEvents(result);
    // }, [dataSetEvents])

    return (
    <ScrollableDialogProps
        open={open}
        title={`Seguimiento de flota`}
        minWidth="40%"
        onClose={handleClose}
        showConfirmBtn={false}
        cancelTextBtn="Cerrar"
        contentNode={<>
        <Grid {...gridSizeMdLg12} container spacing={2}>
            <Grid item {...gridSizeMdLg12} sx={{ height: "auto" }}>
                <Typography variant="h6">Detalles de la actividades del tecnico</Typography>
            </Grid>
            <Grid item {...gridSizeMdLg12}>
                {events?.length > 0 ? (
                <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    initialView={"timeGridDay"}
                    locales={[esLocale]} // Configura el locale a español
                    datesSet={(date) => {
                        console.log(date)
                    }}
                    events={events}
                    initialDate={dayjs(data?.fecha).toDate()} // Establece la fecha por defecto aquí
                    scrollTime="07:00:00"
                    // slotMinTime={{ hour: 7, minute: 0 }}
                    // slotMaxTime={{ hour: 23, minute: 0 }}
                    slotMinTime={"07:00:00"}
                    slotMaxTime={"23:00:00"}
                    allDaySlot={false}
                    eventContent={(eventInfo) => renderEventContent(eventInfo)}
                    headerToolbar={{
                        left: "prev,next today",
                        center: "title",
                        right: "",
                    }}
                    // editable={false} // Desactiva el arrastre de eventos
                    // droppable={false} // Desactiva la posibilidad de soltar eventos
                    // eventResizableFromStart={false} // Desactiva el redimensionamiento
                    // selectable={false}
                    height="auto"            // 👈 esto permite que crezca y se genere scroll
                    contentHeight="auto"
                />
                ) : (
                    <Typography variant="body1">No hay eventos para esta fecha</Typography>
                )}
            </Grid>
            {/* <Grid {...gridSizeMdLg6} container spacing={2}>
                <Grid item {...gridSizeMdLg12}>
                    
                </Grid>
            </Grid> */}
        </Grid>

        </>}
    />
  )
}

function renderEventContent(eventInfo: EventContentArg) {
    return (
        <div className="insideStyle">
            <span>
                <b>{eventInfo.timeText}</b>
            </span>
            <span>{eventInfo.event.title}</span>
            <span className="reason">{eventInfo.event.extendedProps.motivo}</span>
            <span className="username">{eventInfo.event.extendedProps.username}</span>
        </div>
    );
}

export default ModalSeguimientoFlotaPlanificador